import useClubAthleteRosterFilterForm from './UseClubAthleteRosterFilterForm';

import ClubGroupCombobox from '../../../components/comboboxes/clubGroupCombobox/ClubGroupCombobox';

import ClubRosterExport from '@usas/ui-web/components/fileExports/ClubRosterExport';
import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
import Input from '@usas/ui-web/components/inputs/Input';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ClubAthleteRosterFilterForm = ({ clubObj, clubAddressObj, clubRosterArray, athletesToSyncCount, athletesToTransferCount,
  onSubmitAthleteFilter, onClearAthleteFilter, onSubmitAthleteSync, onSubmitAthleteTransfer,
  PRACTICE_GROUP_TYPE_ID, SITE_GROUP_TYPE_ID }) => {
  const {
    formState,
    errorState,
    onFormValueChanged,
    onValueTextPairChanged,
    handleSubmit,
    onClearFilterClicked,
    competitionGenderOptions,
  } = useClubAthleteRosterFilterForm(onSubmitAthleteFilter, onClearAthleteFilter);

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-4">
          <Dropdown
            label="Competition Category"
            name="competitionGenderTypeId"
            options={competitionGenderOptions}
            value={formState.competitionGenderTypeId}
            error={errorState.competitionGenderTypeId}
            message={errorState.competitionGenderTypeId}
            isLoading={false}
            onChange={(newValue, newValueLabel, e) => {
              e?.target?.value && onValueTextPairChanged(newValue, 'competitionGenderTypeId', newValueLabel, 'competitionGenderTypeName');
            }} />
        </div>
        <div className="col-xs-6 col-sm-3 col-md-2">
          <Input
            label="Min Age"
            name="minAge"
            type="number"
            min="1"
            max="99"
            value={formState.minAge}
            error={errorState.minAge}
            message={errorState.minAge}
            onChange={(value) => {
              onFormValueChanged('minAge', value);
            }}
          />
        </div>
        <div className="col-xs-6 col-sm-3 col-md-2">
          <Input
            label="Max Age"
            name="maxAge"
            type="number"
            min="1"
            max="99"
            value={formState.maxAge}
            error={errorState.maxAge}
            message={errorState.maxAge}
            onChange={(value) => {
              onFormValueChanged('maxAge', value);
            }}
          />
        </div>
        {PRACTICE_GROUP_TYPE_ID > 0 && clubObj.orgUnitId && (
          <div className="col-xs-12 col-sm-6 col-md-4">
            <ClubGroupCombobox
              label={'Practice Group'}
              name={'practiceGroupId'}
              valueToMatch={formState.practiceGroupName}
              error={errorState.practiceGroupId}
              message={errorState.practiceGroupId}
              onChange={(newValue, newValueLabel) => {
                onValueTextPairChanged(
                  newValue,
                  'practiceGroupId',
                  newValueLabel,
                  'practiceGroupName'
                );
              }}
              orgUnitId={clubObj.orgUnitId}
              groupTypeId={PRACTICE_GROUP_TYPE_ID} />
          </div>
        )}
        {SITE_GROUP_TYPE_ID > 0 && clubObj.orgUnitId && (
          <div className="col-xs-12 col-sm-6 col-md-4">
            <ClubGroupCombobox
              label={'Site Group'}
              name={'siteGroupId'}
              valueToMatch={formState.siteGroupName}
              error={errorState.siteGroupId}
              message={errorState.siteGroupId}
              onChange={(newValue, newValueLabel, e) => {
                onValueTextPairChanged(
                  newValue,
                  'siteGroupId',
                  newValueLabel,
                  'siteGroupName',
                  e
                );
              }}
              orgUnitId={clubObj.orgUnitId}
              groupTypeId={SITE_GROUP_TYPE_ID}
            />
          </div>
        )}
        <div className="col-xs-12 col-sm-6 col-md-4">
          <Input
            label="First or Preferred Name"
            name="firstOrPreferredName"
            value={formState.firstOrPreferredName}
            error={errorState.firstOrPreferredName}
            message={errorState.firstOrPreferredName}
            onChange={(value) => {
              onFormValueChanged('firstOrPreferredName', value);
            }}
          />
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4">
          <Input
            label="Last Name"
            name="lastName"
            value={formState.lastName}
            error={errorState.lastName}
            message={errorState.lastName}
            onChange={(value) => {
              onFormValueChanged('lastName', value);
            }}
          />
        </div>
      </div>
      <div className='row'>
        <div className="col-xs-6 col-sm-2 col-md-1">
          <button className={global.PlainButton} type="submit">
            Filter
          </button>
        </div>
        <div className="col-xs-6 col-sm-4 col-md-2">
          <button
            className={global.PlainButton}
            type="button"
            onClick={onClearFilterClicked}>
            Clear Filter
          </button>
        </div>
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
          <ClubRosterExport
            clubRosterArray={clubRosterArray}
            orgUnitCode={clubObj.orgUnit?.orgUnitCode}
            orgUnitName={clubObj.orgUnit?.orgUnitName}
            parentOrgUnitCode={clubObj.orgUnit?.parentOrgUnitCode}
            clubCity={clubAddressObj?.address?.city || ''}
            clubStateCode={clubAddressObj?.address?.stateCode || ''}
            clubAddress1={clubAddressObj?.address?.address1 || ''}
            clubPostalCode={clubAddressObj?.address?.postalCode || ''}
            clubEmail={''}
            rosterType={'USAS'} />
        </div>
        {athletesToSyncCount > 0 && (
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
            <button
              className={global.PlainButton}
              type="button"
              onClick={onSubmitAthleteSync}>
              Sync Selected Members
            </button>
          </div>
        )}
        {athletesToTransferCount > 0 && (
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
            <button
              className={global.PlainButton}
              type="button"
              onClick={onSubmitAthleteTransfer}>
              Transfer Selected Members
            </button>
          </div>
        )}
      </div>
    </form>
  );
};

export default ClubAthleteRosterFilterForm;
